import React from 'react';
import AddMechanic from './addMechanic';
import MechanicList from './mechanicList';
import { useLanguage } from '../../Services/LanguageContext';

const MechanicPage = () => {
    const { t } = useLanguage();
    return (
        <div className='flex flex-col w-full' style={{ animation: 'fade-in 0.3s ease' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '32px',
                    paddingBottom: '20px',
                    borderBottom: '1px solid var(--border-color)',
                }}
            >
                <h1
                    style={{
                        fontSize: '32px',
                        fontWeight: 700,
                        margin: 0,
                        background: 'linear-gradient(135deg, var(--text-primary), var(--accent-cyan))',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}
                >
                    {t('mechanics')}
                </h1>
                <AddMechanic />
            </div>
            <div
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    paddingRight: '8px',
                }}
            >
                <MechanicList />
            </div>
        </div>
    );
};

export default MechanicPage;
